import useOrganization from "@hooks/useOrganization";
import { useGetPortalDevicesQuery } from "@queries/tanstack/device/DeviceQuery";
import _ from "lodash";
import { useMemo } from "react";

interface LocationListaram {
  deviceIds: string[];
}
export const useLocationListByDeviceId = (param: LocationListaram) => {
  const { orgId } = useOrganization();
  const { data: portalDeviceData, isLoading: isLoadingPortalDevice } =
    useGetPortalDevicesQuery(
      {
        orgId,
        sightmindStatus: true
      },
      {
        enabled: !!orgId,
        staleTime: 1000 * 60 * 60,
        cacheTime: 1000 * 60 * 60,
        refetchOnMount: true
      }
    );

  const toLocations = (deviceIds: string[]) => {
    if (portalDeviceData) {
      const groupByIds = _.groupBy(portalDeviceData, "id");
      const locations = _.uniqBy(
        _.compact(
          _.map(deviceIds, (deviceId) => {
            const dinfo = groupByIds[deviceId]?.[0];
            if (dinfo && dinfo.locationId && dinfo.locationName) {
              return {
                id: dinfo.locationId,
                name: dinfo.locationName
              };
            }

            return null;
          })
        ),
        "id"
      );

      return locations;
    }
    return undefined;
  };

  const locations = useMemo(
    () => toLocations(param.deviceIds),
    [param.deviceIds]
  );

  return { data: locations, isLoading: isLoadingPortalDevice, toLocations };
};
